import { AppBar, createStyles, Hidden, Theme, Toolbar, Typography, WithStyles, withStyles } from '@material-ui/core/'
import * as React from 'react'
import { NavLink, Route, Switch } from 'react-router-dom'

import Logo from '../Assets/dms_logo.png'
import Main from './Main/Main'
import RealLogos from "./REALLogos/RealLogos";

interface BootstrapProps extends WithStyles<typeof styles> {}

class Bootstrap extends React.Component<BootstrapProps, {}> {
  public render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.appContainer}>
          <div className={classes.appHeader}>
            <header>
              <AppBar
                position="static"
                color="default"
                className={classes.appBar}
                data-auto="main-header"
                aria-label="RI Department of labor and training"
              >
                <Toolbar
                  variant="dense"
                  className={`${classes.layoutBreakpoints} ${classes.toolbar}`}
                >
                  <nav className={classes.navigation} role="navigation">
                    <NavLink to="/" className={classes.branding}>
                      <div className={classes.logoContainer}>
                        <img
                          className={classes.logo}
                          src={Logo}
                          alt="dms logo"
                        />
                      </div>
                      <Hidden smDown={true}>
                        <div className={classes.titleContainer}>
                          <Typography className={`${classes.title} ${classes.titleHead}`} component="h1" variant="h6">
                            Governor's Workforce Board
                          </Typography>
                          <Typography className={`${classes.title}  ${classes.titleMid}`}>RHODE ISLAND</Typography>
                          <Typography className={`${classes.title}  ${classes.titleBottom}`}>
                            train for success &#8226; connect for growth
                          </Typography>
                        </div>
                      </Hidden>
                    </NavLink>
                  </nav>
                </Toolbar>
              </AppBar>
            </header>
          </div>
          <div
            className={`${classes.layoutBreakpoints} ${classes.siteContent}`}
          >
            <Switch>
              <Route exact={true} path="/" component={Main} />
            </Switch>
          </div>
        </div>
        <footer className={classes.footer}>
          <RealLogos />
        </footer>
      </div>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      minHeight: '100vh',
      flexDirection: 'column'
    },
    appContainer: {
      flex: '1'
    },
    appHeader: {
      flexBasis: '50px'
    },
    appBar: {},
    toolbar: {},
    siteContent: {
      paddingTop: theme.spacing.unit * 3,
      display: 'flex'
    },
    layoutBreakpoints: {
      margin: '0 auto',
      [theme.breakpoints.up('lg')]: {
        width: '80%'
      },
      [theme.breakpoints.down('md')]: {
        width: '95%'
      }
    },
    navigation: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between'
    },
    branding: {
      display: 'flex',
      alignItems: 'center',
      height: '50px',
      textDecoration: 'none',

      [theme.breakpoints.up('sm')]: {
        flexBasis: '50%'
      }
    },
    titleContainer: {
      maxHeight: '50px',
      overflow: 'hidden'
    },
    title: {
      fontSize: `${theme.typography.fontSize * 0.75}px`,
      lineHeight: 1.25,
      color: 'primary'
    },
    titleHead: {
      fontSize: `${theme.typography.fontSize}px`,
      letterSpacing: '2px',
      fontWeight: 'bolder',
      color: 'primary'
    },
    titleMid: {
      fontStyle: 'oblique',
      textTransform: 'uppercase',
      color: 'primary'
    },
    titleBottom: {
      fontWeight: 500
    },
    logoContainer: {
      height: '55px',
      display: 'flex',
    },
    logo: {
      transform: 'scale(0.75, 0.75)',
    },
    footer: {
      display: 'flex',
      justifyContent: 'center'
    }
	})

export default withStyles(styles)(Bootstrap);



// WEBPACK FOOTER //
// ./src/components/Bootstrap.tsx